<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>Contact Us</h1>
        <p>Get in touch with our team to discuss how we can help your business expand internationally.</p>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section">
      <div class="container">
        <div class="section-title">
          <h2>Get In Touch</h2>
          <p>You can submit your expansion needs via the form below so we can get in touch.</p>
        </div>
        
        <div class="contact-container">
          <div class="contact-info">
            <h3>Our Contact Information</h3>
            <p>You can also reach us through the following information:</p>
            
            <div class="contact-details">
              <div class="contact-item">
                <i class="fas fa-envelope"></i>
                <div>
                  <h4>Email</h4>
                  <p>info@roadlinkglb.com</p>
                </div>
              </div>
              
              <div class="contact-item">
                <i class="fas fa-phone"></i>
                <div>
                  <h4>Phone</h4>
                  <p>+1 (555) 123-4567</p>
                </div>
              </div>
              
              <div class="contact-item">
                <i class="fas fa-map-marker-alt"></i>
                <div>
                  <h4>Address</h4>
                  <p>123 Business Ave, Suite 100</p>
                  <p>New York, NY 10001</p>
                </div>
              </div>
              
              <div class="contact-item">
                <i class="fas fa-clock"></i>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p>Saturday: 10:00 AM - 2:00 PM</p>
                </div>
              </div>
            </div>
            
            <div class="social-links">
              <h4>Follow Us</h4>
              <div class="social-icons">
                <a href="#"><i class="fab fa-linkedin"></i></a>
                <a href="#"><i class="fab fa-twitter"></i></a>
                <a href="#"><i class="fab fa-facebook"></i></a>
                <a href="#"><i class="fab fa-instagram"></i></a>
              </div>
            </div>
          </div>
          
          <div class="contact-form">
            <h3>Send Us a Message</h3>
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <label for="name">Full Name</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="form.name" 
                  placeholder="Your full name" 
                  required>
              </div>
              
              <div class="form-group">
                <label for="email">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  v-model="form.email" 
                  placeholder="Your email address" 
                  required>
              </div>
              
              <div class="form-group">
                <label for="company">Company Name</label>
                <input 
                  type="text" 
                  id="company" 
                  v-model="form.company" 
                  placeholder="Your company name">
              </div>
              
              <div class="form-group">
                <label for="subject">Subject</label>
                <select id="subject" v-model="form.subject" required>
                  <option value="">Select a subject</option>
                  <option value="market-diagnosis">Market Diagnosis</option>
                  <option value="market-entry">Market Entry</option>
                  <option value="partnership">Partnership</option>
                  <option value="logistics">Logistics & Supply Chain</option>
                  <option value="compliance">Legal & Compliance</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div class="form-group">
                <label for="region">Target Region</label>
                <select id="region" v-model="form.region">
                  <option value="">Select target region</option>
                  <option value="asia">Asia</option>
                  <option value="europe">Europe</option>
                  <option value="americas">Americas</option>
                  <option value="middle-east">Middle East</option>
                  <option value="africa">Africa</option>
                </select>
              </div>
              
              <div class="form-group">
                <label for="message">Your Message</label>
                <textarea 
                  id="message" 
                  rows="5" 
                  v-model="form.message" 
                  placeholder="Please describe your products, objectives, and any specific requirements..."
                  required></textarea>
              </div>
              
              <button type="submit" class="btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner"></span>
                <span v-else>Send Message</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <section class="map-section">
      <div class="container">
        <div class="map-placeholder">
          <i class="fas fa-map-marked-alt"></i>
          <h3>Our Location</h3>
          <p>123 Business Ave, Suite 100, New York, NY 10001</p>
          <button class="btn-secondary">View on Google Maps</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        company: '',
        subject: '',
        region: '',
        message: ''
      }
    }
  },
  methods: {
    async submitForm() {
      this.loading = true
      
      // 模拟API调用
      try {
        await new Promise(resolve => setTimeout(resolve, 1500))
        alert('Thank you for your message! We will get back to you soon.')
        
        // 重置表单
        this.form = {
          name: '',
          email: '',
          company: '',
          subject: '',
          region: '',
          message: ''
        }
      } catch (error) {
        alert('There was an error sending your message. Please try again.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(26, 58, 95, 0.85), rgba(26, 58, 95, 0.9)), url('https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 80px 0;
  text-align: center;
}

.hero h1 {
  font-size: 42px;
  margin-bottom: 20px;
}

.hero p {
  font-size: 18px;
  max-width: 700px;
  margin: 0 auto 30px;
}

.contact-section {
  padding: 80px 0;
  background-color: white;
}

.contact-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
}

.contact-info h3 {
  color: #1a3a5f;
  margin-bottom: 20px;
  font-size: 24px;
}

.contact-info > p {
  margin-bottom: 30px;
  line-height: 1.6;
}

.contact-details {
  margin-bottom: 40px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}

.contact-item i {
  color: #4dabf7;
  font-size: 20px;
  margin-right: 15px;
  margin-top: 5px;
}

.contact-item h4 {
  color: #1a3a5f;
  margin-bottom: 5px;
  font-size: 18px;
}

.contact-item p {
  margin-bottom: 3px;
  color: #666;
}

.social-links h4 {
  color: #1a3a5f;
  margin-bottom: 15px;
  font-size: 18px;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icons a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #4dabf7;
  color: white;
  border-radius: 50%;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.social-icons a:hover {
  background-color: #3b99e0;
}

.contact-form {
  background-color: #f5f7fa;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.contact-form h3 {
  color: #1a3a5f;
  margin-bottom: 20px;
  font-size: 24px;
}

.map-section {
  padding: 80px 0;
  background-color: #f5f7fa;
}

.map-placeholder {
  background: linear-gradient(135deg, #4dabf7 0%, #1a3a5f 100%);
  color: white;
  text-align: center;
  padding: 60px 30px;
  border-radius: 8px;
}

.map-placeholder i {
  font-size: 60px;
  margin-bottom: 20px;
}

.map-placeholder h3 {
  margin-bottom: 15px;
  font-size: 24px;
}

.map-placeholder p {
  margin-bottom: 25px;
  font-size: 18px;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 992px) {
  .contact-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 32px;
  }
  
  .hero p {
    font-size: 16px;
  }
  
  .contact-section {
    padding: 50px 0;
  }
  
  .map-section {
    padding: 50px 0;
  }
}
</style>